// Interactive Google Maps for the contact page.
//
// Self-guarding IIFE: no-ops on pages without [data-contact-map].
// Loads the Google Maps JS API on demand (only when this page is rendered)
// and mounts a map with one marker per location. Clicking a marker opens
// an InfoWindow with the address.
//
// Server-rendered data attributes carry everything the client needs:
//   - data-api-key       Google Maps JS API key
//   - data-markers       JSON [{ lat, lng, html }]
//   - data-loading-label string shown while the script loads
//   - data-error-label   string shown if loading fails
(function () {
  var mapEl = document.querySelector('[data-contact-map]');
  if (!mapEl) return;

  var apiKey = mapEl.getAttribute('data-api-key');
  var markersAttr = mapEl.getAttribute('data-markers');
  var errorLabel = mapEl.getAttribute('data-error-label') || 'Could not load map';
  var statusEl = mapEl.querySelector('[data-contact-map-status]');

  function showError() {
    if (statusEl) statusEl.textContent = errorLabel;
  }

  if (!apiKey || !markersAttr) {
    showError();
    return;
  }

  var markers;
  try {
    markers = JSON.parse(markersAttr);
  } catch (e) {
    showError();
    return;
  }
  if (!Array.isArray(markers) || markers.length === 0) {
    showError();
    return;
  }

  // Suppress Google's default POI labels for a calmer-looking map.
  var MAP_STYLES = [
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }],
    },
  ];

  // Maps fires this global on key/auth failure (e.g. invalid key, referrer
  // restriction violation). Set BEFORE the script loads so we catch the
  // very first failed request. Coexists with any prior handler.
  var prevAuthFailure = window.gm_authFailure;
  window.gm_authFailure = function () {
    showError();
    if (typeof prevAuthFailure === 'function') prevAuthFailure();
  };

  function mountMap() {
    if (typeof google === 'undefined' || !google.maps) {
      showError();
      return;
    }

    // Wrap mount in try/catch — without it a throw inside the Maps init
    // (rare but possible: malformed marker data, runtime API change) would
    // leave the loading placeholder visible forever.
    try {
      mountMapImpl();
    } catch (err) {
      showError();
    }
  }

  function mountMapImpl() {
    var map = new google.maps.Map(mapEl, {
      styles: MAP_STYLES,
      disableDefaultUI: true,
      gestureHandling: 'cooperative',
      keyboardShortcuts: false,
      clickableIcons: false,
    });

    var bounds = new google.maps.LatLngBounds();
    var openInfo = null;

    markers.forEach(function (m) {
      var position = { lat: Number(m.lat), lng: Number(m.lng) };
      var marker = new google.maps.Marker({
        position: position,
        map: map,
      });
      bounds.extend(position);

      if (m.html) {
        var info = new google.maps.InfoWindow({ content: m.html });
        marker.addListener('click', function () {
          if (openInfo) openInfo.close();
          info.open({ map: map, anchor: marker });
          openInfo = info;
        });
      }
    });

    if (markers.length === 1) {
      map.setCenter({ lat: Number(markers[0].lat), lng: Number(markers[0].lng) });
      map.setZoom(13);
    } else {
      map.fitBounds(bounds, { top: 60, right: 60, bottom: 60, left: 60 });
    }

    // Status placeholder no longer needed once the map mounts.
    if (statusEl && statusEl.parentNode) {
      statusEl.parentNode.removeChild(statusEl);
    }
  }

  // Reuse an in-flight or completed load if another caller already started one.
  if (window.__smdGoogleMapsLoaded) {
    mountMap();
    return;
  }

  if (window.__smdGoogleMapsLoading) {
    window.__smdGoogleMapsLoading.then(mountMap, showError);
    return;
  }

  window.__smdGoogleMapsLoading = new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.src =
      'https://maps.googleapis.com/maps/api/js?key=' +
      encodeURIComponent(apiKey) +
      '&v=weekly';
    script.async = true;
    script.defer = true;
    script.onload = function () {
      window.__smdGoogleMapsLoaded = true;
      resolve();
    };
    script.onerror = function () {
      reject(new Error('Failed to load Google Maps JS API'));
    };
    document.head.appendChild(script);
  });

  window.__smdGoogleMapsLoading.then(mountMap, showError);
})();
